export default function (input) {
  const value = input.replace("-", "")
  const validator = new RegExp("^(0[1-9]|[12][0-9]|3[01])(0[1-9]|1[0-2])[0-9]{6}$")
  return validator.test(value)
}
